import { useFetchPartnerFeatures } from 'hooks/queries/useFetchPartnerFeatures';

/**
 * Partner DLM v2 toggle — `features.app.enableDlmV2` from partner-data (`/api/features/read`).
 *
 * On: the partner iframe owns the DLM lifecycle (draft/view mode, status and version), so the
 * portal stops passing partnerStatus/version into the core-data iframe and hides the draft switch.
 *
 * `undefined` while the flag is still loading — callers must wait, or the iframe boots in the wrong mode.
 * A failed request falls back to `false` (v1 behaviour).
 */
export const usePartnerDlmV2Enabled = (): boolean | undefined => {
  const { data, isPending } = useFetchPartnerFeatures();
  return isPending ? undefined : data?.app?.enableDlmV2 === true;
};
